// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickJournalDuneRouteNodes__routeNode___ggI2I {
    animation: QuickJournalDuneRouteNodes__quickJournalDuneRouteNodePulse___SQC6t 7.6s ease-in-out infinite;
}

@keyframes QuickJournalDuneRouteNodes__quickJournalDuneRouteNodePulse___SQC6t {
    0%,
    100% {
        opacity: var(--quickJournalDuneRouteNodeRestOpacity, 0.28);
        transform: translate(-50%, -50%) scale(0.86);
    }

    44%,
    56% {
        opacity: 0.72;
        transform: translate(-50%, -50%) scale(1.15);
    }

    50% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1.34);
    }
}

@media (prefers-reduced-motion: reduce) {
    .QuickJournalDuneRouteNodes__routeNode___ggI2I {
        animation: none;
        /* Keep the reduced-motion scene static without hiding its route nodes. */
        opacity: 0.38;
        opacity: max(
            var(--quickJournalDuneRouteNodeRestOpacity, 0.28),
            0.38
        );
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"routeNode": `QuickJournalDuneRouteNodes__routeNode___ggI2I`,
	"quickJournalDuneRouteNodePulse": `QuickJournalDuneRouteNodes__quickJournalDuneRouteNodePulse___SQC6t`
};
module.exports = ___CSS_LOADER_EXPORT___;
